import { COLORS } from "../../../../../utils/colors"


export const eventsModalStyles = () => {
    return {
        modal: {
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minHeight: '10rem',
            minWidth: '12rem',
            width: 'auto',
            height: 'auto',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            outline: 'none',
            borderRadius: '0.5rem',
            padding: '0.5rem',
            paddingBottom: '2rem',
    
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          close: {
            position: 'absolute',
            top: '.25rem',
            left: '.25rem',
            padding: '.5rem',
            minWidth: '2rem',
            fontWeight: 'bold'
          },
          toolTipContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            overflow: 'hidden',
            flexGrow: 1,
            marginBottom: 'auto',
          },
          eventContainer: {
            display: 'flex',
            backgroundColor: 'transparent !important',
            border: 'none !important',
            padding: '0px !important',
            alignItems: 'center',
            marginBottom: '0.5rem'
          },
          SpotBookingIcon: {
            borderRadius: '1rem',
            width: '10px',
            height: '10px',
            backgroundColor: COLORS.PRIMARY,
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
          ProblemSolverIcon: {
            borderRadius: '1rem',
            width: '10px',
            height: '10px',
            backgroundColor: '#bb1977',
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
          BundleHelpIcon: {
            borderRadius: '1rem',
            width: '10px',
            height: '10px',
            backgroundColor: 'rgb(64, 129, 195)',
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          },
          UnlimitedHelpIcon: {
            borderRadius: '1rem',
            width: '10px',
            height: '10px',
            backgroundColor: 'rgb(22, 157, 11)',
            marginRight: '0.25rem',
            marginLeft: '0.25rem',
          }
    }
}